import * as React from "react";
const SvgPricingIllustration = (props) => /* @__PURE__ */ React.createElement("svg", { width: 240, height: 200, viewBox: "0 0 240 200", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M40 176H200", style: {
  stroke: "rgb(var(--landing-stone-400, 200 192 178))"
}, strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M56 60C56 55.5817 59.5817 52 64 52H132L172 92L112 152L56 96V60Z", transform: "rotate(-8 114 102)", style: {
  fill: "rgb(var(--landing-white, 255 255 255))",
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 80, cy: 76, r: 8, transform: "rotate(-8 114 102)", style: {
  fill: "rgb(var(--landing-surface, 251 248 242))",
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2.5 }), /* @__PURE__ */ React.createElement("path", { d: "M80 76C70 60 52 52 40 60", transform: "rotate(-8 114 102)", style: {
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("text", { x: 118, y: 116, textAnchor: "middle", transform: "rotate(-8 114 102)", style: {
  fill: "rgb(var(--landing-red, 192 57 43))",
  fontFamily: "Fraunces, Georgia, serif",
  fontWeight: 600
}, fontSize: 40 }, "$"));
export default SvgPricingIllustration;
